/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { IFloatingFilter, IFloatingFilterParams } from 'ag-grid-community';
import { distinctUntilChanged, tap } from 'rxjs';

@Component({
  selector: 'ag-grid-selector-floating-filter',
  templateUrl: './ag-grid-selector-floating-filter.component.html',
  styleUrls: ['./ag-grid-selector-floating-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisAgGridSelectorFloatingFilterComponent implements IFloatingFilter {
  private readonly destroyRef = inject(DestroyRef);

  readonly fieldControl = new FormControl<string>(null);

  readonly params = signal<IFloatingFilterParams>(null);
  readonly entities = signal([]);
  readonly label = signal('');

  agInit(params: IFloatingFilterParams): void {
    this.params.set(params);
    this.entities.set(params['directory'] || []);
    this.label.set(params['label'] || '');
    this.fieldControl.setValue(params['value'] || null);
    
    this.handleControlChanges();
  }

  onParentModelChanged(parentModel: any): void {
    const parentModelValue = !parentModel ? null : parentModel.filter;
    if (parentModelValue !== this.fieldControl.value) {
      this.fieldControl.patchValue(parentModelValue);
    }
  }

  private handleControlChanges(): void {
    this.fieldControl.valueChanges.pipe(
      distinctUntilChanged(),
      tap(value => {
        this.params().parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('textFilter', value);
        });
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
